import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment as env } from '../../environments/environment';
import { Codes } from '../models/code.model';
import { map, filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CodesApiService {

  codes: BehaviorSubject<Codes[]> = new BehaviorSubject([]);
  loading: BehaviorSubject<boolean> = new BehaviorSubject(false);
  lastUpdate = 0;

  public certificates$ = this.codes.pipe(
    map((codes) => codes.find(code => code.codeType === env.certificateCodeType)?.codes),
    filter(x => !!x)
  );

  constructor(private http: HttpClient) {
    this.update();
  }

  update(): BehaviorSubject<Codes[]> {
    const now = Date.now();
    if (now - this.lastUpdate > 60 * 1000) {
      this.lastUpdate = now;
      this.fetch();
    }
    return this.codes;
  }

  fetch() {
    this.loading.next(true);
    this.http.get<Codes[]>(`${env.apiPath}/codes`)
      .toPromise()
      .then(data => {
        this.codes.next(data);
        this.loading.next(false);
      })
      .catch(error => {
        this.loading.next(false);
      });
  }
}
